<template>
    <button
        class="btn-default"
        :class="[classHandler, buttonType]"
        :style="colorHandler"
    >
        <span>
            <slot />
        </span>
    </button>
</template>

<script>
import { colorMixin } from '@/mixins';

export default {
    name: 'DefaultButton',
    props: {
        fill: {
            type: String,
        },
        large: {
            type: Boolean,
            default: false,
        },
        buttonType: {
            type: String,
            default: 'default',
        },
    },
    mixins: [colorMixin],
    computed: {
        classHandler() {
            return {
                __large: this.large,
            };
        },
        colorHandler() {
            return this.fill
                ? {
                      '--primary': this.fill,
                      '--color': this.isColorLight(this.fill) ? '#333' : '#fff',
                  }
                : {};
        },
    },
};
</script>

<style lang="scss" scoped>
.btn-default {
    display: flex;
    cursor: pointer;
    position: relative;
    border-radius: 5px;
    width: 100%;
    text-align: center;
    padding: 0 15px;
    &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        border-radius: inherit;
    }
    &.__large {
        max-height: 48px;
        span {
            line-height: 48px;
        }
    }

    span {
        margin: auto;
        position: relative;
        z-index: 1;
        text-transform: capitalize;
        font-weight: bold;
        line-height: 22px;
    }
}

.btn-default.default {
    color: #fff;
    color: var(--color);
    &::after {
        background: var(--primary);
    }

    &:hover:after {
        filter: brightness(0.95) drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));
    }
}

.btn-default.basic {
    color: var(--primary);
    &::after {
        background: transparent;
    }

    &:hover:after {
        background: var(--primary);
        opacity: 0.08;
        filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));
    }
    &:hover span {
        filter: brightness(0.95);
    }
}

.btn-default.outline {
    color: var(--primary);
    border: 1px solid var(--primary);
    &::after {
        background: transparent;
    }

    &:hover:after {
        background: var(--primary);
        opacity: 0.08;
        filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));
    }
    &:hover span {
        filter: brightness(0.95);
    }
}

button {
    background: transparent;
}
</style>
